/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiMemberDtoCustomMemberFieldValueDto } from './WebApiMemberDtoCustomMemberFieldValueDto';
import {
    WebApiMemberDtoCustomMemberFieldValueDtoFromJSON,
    WebApiMemberDtoCustomMemberFieldValueDtoFromJSONTyped,
    WebApiMemberDtoCustomMemberFieldValueDtoToJSON,
} from './WebApiMemberDtoCustomMemberFieldValueDto';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import type { WebApiModelsEnumerationTypesMemberStatus } from './WebApiModelsEnumerationTypesMemberStatus';
import {
    WebApiModelsEnumerationTypesMemberStatusFromJSON,
    WebApiModelsEnumerationTypesMemberStatusFromJSONTyped,
    WebApiModelsEnumerationTypesMemberStatusToJSON,
} from './WebApiModelsEnumerationTypesMemberStatus';

/**
 * 
 * @export
 * @interface WebApiMemberDtoAddMemberObjectDto
 */
export interface WebApiMemberDtoAddMemberObjectDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    email2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    postalArea?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    title?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    phoneNumber2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    personalNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    adressRow2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    adressRow3?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    joinedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    webPage?: string | null;
    /**
     * 
     * @type {Array<WebApiMemberDtoCustomMemberFieldValueDto>}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    customFieldValues?: Array<WebApiMemberDtoCustomMemberFieldValueDto> | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    company?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    uniqueId?: string | null;
    /**
     * Optional. When set, this row is imported as a family member of the household whose
     * primary member has this member number (UniqueId). Only used when the company has
     * FamilyMemberConfiguration enabled.
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    primaryMemberNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    extra1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    extra2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    extra3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    groups?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    membership?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberStatus}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    status?: WebApiModelsEnumerationTypesMemberStatus;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    paymentAmountYearMinusTwo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    paymentAmountYearMinusOne?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    paymentAmountCurrentYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoAddMemberObjectDto
     */
    paymentAmountNextYear?: number | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoAddMemberObjectDto interface.
 */
export function instanceOfWebApiMemberDtoAddMemberObjectDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoAddMemberObjectDtoFromJSON(json: any): WebApiMemberDtoAddMemberObjectDto {
    return WebApiMemberDtoAddMemberObjectDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoAddMemberObjectDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoAddMemberObjectDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'email2': !exists(json, 'email2') ? undefined : json['email2'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'postalArea': !exists(json, 'postalArea') ? undefined : json['postalArea'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'phoneNumber2': !exists(json, 'phoneNumber2') ? undefined : json['phoneNumber2'],
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
        'adressRow2': !exists(json, 'adressRow2') ? undefined : json['adressRow2'],
        'adressRow3': !exists(json, 'adressRow3') ? undefined : json['adressRow3'],
        'joinedDate': !exists(json, 'joinedDate') ? undefined : (new Date(json['joinedDate'])),
        'webPage': !exists(json, 'webPage') ? undefined : json['webPage'],
        'customFieldValues': !exists(json, 'customFieldValues') ? undefined : (json['customFieldValues'] === null ? null : (json['customFieldValues'] as Array<any>).map(WebApiMemberDtoCustomMemberFieldValueDtoFromJSON)),
        'company': !exists(json, 'company') ? undefined : json['company'],
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'primaryMemberNumber': !exists(json, 'primaryMemberNumber') ? undefined : json['primaryMemberNumber'],
        'extra1': !exists(json, 'extra1') ? undefined : json['extra1'],
        'extra2': !exists(json, 'extra2') ? undefined : json['extra2'],
        'extra3': !exists(json, 'extra3') ? undefined : json['extra3'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'membership': !exists(json, 'membership') ? undefined : json['membership'],
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesMemberStatusFromJSON(json['status']),
        'paymentAmountYearMinusTwo': !exists(json, 'paymentAmountYearMinusTwo') ? undefined : json['paymentAmountYearMinusTwo'],
        'paymentAmountYearMinusOne': !exists(json, 'paymentAmountYearMinusOne') ? undefined : json['paymentAmountYearMinusOne'],
        'paymentAmountCurrentYear': !exists(json, 'paymentAmountCurrentYear') ? undefined : json['paymentAmountCurrentYear'],
        'paymentAmountNextYear': !exists(json, 'paymentAmountNextYear') ? undefined : json['paymentAmountNextYear'],
    };
}

export function WebApiMemberDtoAddMemberObjectDtoToJSON(value?: WebApiMemberDtoAddMemberObjectDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'email2': value.email2,
        'address': value.address,
        'postalCode': value.postalCode,
        'postalArea': value.postalArea,
        'title': value.title,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'country': value.country,
        'phoneNumber': value.phoneNumber,
        'phoneNumber2': value.phoneNumber2,
        'personalNumber': value.personalNumber,
        'adressRow2': value.adressRow2,
        'adressRow3': value.adressRow3,
        'joinedDate': value.joinedDate === undefined ? undefined : (value.joinedDate.toISOString().substr(0,10)),
        'webPage': value.webPage,
        'customFieldValues': value.customFieldValues === undefined ? undefined : (value.customFieldValues === null ? null : (value.customFieldValues as Array<any>).map(WebApiMemberDtoCustomMemberFieldValueDtoToJSON)),
        'company': value.company,
        'uniqueId': value.uniqueId,
        'primaryMemberNumber': value.primaryMemberNumber,
        'extra1': value.extra1,
        'extra2': value.extra2,
        'extra3': value.extra3,
        'groups': value.groups,
        'membership': value.membership,
        'status': WebApiModelsEnumerationTypesMemberStatusToJSON(value.status),
        'paymentAmountYearMinusTwo': value.paymentAmountYearMinusTwo,
        'paymentAmountYearMinusOne': value.paymentAmountYearMinusOne,
        'paymentAmountCurrentYear': value.paymentAmountCurrentYear,
        'paymentAmountNextYear': value.paymentAmountNextYear,
    };
}

